module.exports = __webpack_public_path__ + "img/Flip Card 3.cbaf5115.svg";